<!--
    File: cgp-check-all.template.html
    Author: Joseph M Diaz
    Date: 6/12/2018
    Desc: Template for the CGP Check All Component.
    Other Contributors:
-->

<div class="cgp-check-all-container" [ngClass]="{raised: isRaised(), pagination: pagination, disabled: disabled}">
    <button mat-icon-button (click)="onCheckClick()" [disabled]="disabled" [disableRipple]="true">
        <i class="fa fa-lg" [ngClass]="checkIcon()"></i>
    </button>

    <ng-container *ngIf="pagination">
        <button mat-icon-button class="caret-down" [matMenuTriggerFor]="checkAllMenu" [disabled]="disabled" [disableRipple]="true">
            <i class="fa fa-caret-down"></i>
        </button>
        <mat-menu #checkAllMenu="matMenu">
            <button mat-menu-item (click)="selectPage()">
                <i class="fa fa-file"></i>
                <span>Select Current Page</span>
            </button>
            <button mat-menu-item (click)="selectAllPages()">
                <i class="fa fa-table"></i>
                <span>Select All Pages</span>
            </button>
            <button mat-menu-item (click)="deselectPage()">
                <i class="fa fa-file deselect"></i>
                <span>Deselect Current Page</span>
            </button>
            <button mat-menu-item (click)="deselectAllPages()">
                <i class="fa fa-table deselect"></i>
                <span>Deselect All Pages</span>
            </button>
        </mat-menu>
    </ng-container>
</div>